import FadeLoader from "react-spinners/FadeLoader";
import '../estilos.css';


function Cargando() {
  return (
    <div className="miDivMed">
<FadeLoader
  color="#34cf26"
  height={10}
  loading
  margin={2}
  radius={3}
  width={2}
/>
    </div>
  );
}

export default Cargando;